import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {gameUiTexts, schoolUiTexts} from 'data/ui-texts';
import {soundsData} from 'data/sound-data';
import Button from 'components/ui/button/button';
import Logo from 'components/ui/logo/logo';
import Leaderboard from 'components/ui/leaderboard/leaderboard';
import './game-done.scss';

const GameDone = (props) => {
	/* Props */
	const {
		gameGroups, 
		handleGoToPage, 
		updateBackground, 
		scenarioId, 
		handlePlayMusic, 
		updateGroup, 
		updateGame
	} = props;

	/* Track if updating game status */
	const [isUpdatingGame, setIsUpdatingGame] = useState(false);

	const [showLeaderboard, setShowLeaderboard] = useState(false);
	
	// Navigates back to landing page and stops the music
	const handleGoBack = () => {
		handlePlayMusic(false, null);
		handleGoToPage('landing');
	};

	const handleGoToQuestions = () => {
		if (isUpdatingGame) return;
		setIsUpdatingGame(true);
		
		updateGame({status: 'discussion'}).then(() => {
			setIsUpdatingGame(false);
		}).catch((error) => {
			console.error(error);
			setIsUpdatingGame(false);
		});
	};

	const handleGoToEvaluation = () => {
		if (isUpdatingGame) return;
		setIsUpdatingGame(true);
		
		updateGame({status: 'evaluation'}).then(() => {
			setIsUpdatingGame(false);
		}).catch((error) => {
			console.error(error);
			setIsUpdatingGame(false);
		});
	};

	useEffect(() => {
		// Set background image id
		updateBackground('school', scenarioId);
		const audioName = scenarioId + 'Music';
		handlePlayMusic(false, soundsData[audioName]);
		
		return () => {
			handlePlayMusic(false, null);
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);	

	return (
		<div className="GameDone">
			{/* Logo */}
			<div className="GameDone-logo" onClick={() => {handleGoToPage('landing');}} >
				<Logo scenarioId={scenarioId} />
			</div>


			{/* Content */}
			<div className="GameDone-content">
				<div className="GameDone-title">
					<span>{gameUiTexts.gameOver}</span>
				</div>
				<div className="GameDone-buttons">
					<div className="GameDone-btn">
						<Button 
							classes={['blueLight', scenarioId, 'trophy', 'responsive']}
							text={schoolUiTexts.leaderboard}
							onClick={() => {setShowLeaderboard(true);}}
						/>
					</div>
					<div className="GameDone-btn">
						<Button 
							classes={['blueLight', scenarioId, 'responsive']}
							text={schoolUiTexts.gameDonePage.continueToQuestions}
							onClick={() => {handleGoToQuestions();}}
						/>
					</div>
					<div className="GameDone-btn">
						<Button 
							classes={['blueLight', scenarioId, 'responsive']}
							text={schoolUiTexts.gameDonePage.continueToEvaluation}
							onClick={() => {handleGoToEvaluation();}}
						/>
					</div>
					<div className="GameDone-backBtn">
						<Button 
							classes={['blueLight', scenarioId, 'backBtn', 'responsive']}
							text={schoolUiTexts.back}
							onClick={() => {handleGoBack();}}
						/>
					</div>
				</div>
			</div>
		
			{/* Leaderboard  */}
			{showLeaderboard && <div className="GameDone-leaderBoard">
				<div className='GameDone-leaderBoardTitle'><span>{schoolUiTexts.gameDonePage.title}</span></div>
				<div className='GameDone-closeLeaderboardBtn' onClick={() => {setShowLeaderboard(false); }}/>
				<Leaderboard 
					scenarioId={scenarioId} 
					status="done" 
					gameGroups={gameGroups} 
					updateGroup={updateGroup}
				/>
			</div>}

		</div>
	);
};

GameDone.propTypes = {
	gameGroups: PropTypes.array.isRequired,
	handleGoToPage: PropTypes.func.isRequired,
	updateBackground: PropTypes.func.isRequired,
	scenarioId: PropTypes.string.isRequired,
	handlePlayMusic: PropTypes.func.isRequired,
	updateGroup: PropTypes.func.isRequired,
	updateGame: PropTypes.func.isRequired
};

export default GameDone;
